import { RequirePermission } from '@saniplus/ui';
import type { RouteObject } from 'react-router';

import { PermissionFallback } from '../../components/shared/PermissionFallback';

/**
 * A25 — `/parametres`, gated on `settings:read`.
 *
 * `settings:read` and `settings:write` are granted to nobody in
 * `role_permissions`: only `AuthContextService.platformAdminContext()` holds
 * them, so this route is platform-admin-only in practice. The **read** gate is
 * the route; the **write** gate is inside the page, which renders the same
 * ledger with every control disabled and no save bar — an administrator who
 * cannot edit the policy still needs to be able to read it.
 *
 * Exported as an array for the integrator to splice into `app/router.tsx`.
 */
export const routes: RouteObject[] = [
  {
    path: '/parametres',
    element: <RequirePermission permission="settings:read" fallback={<PermissionFallback />} />,
    children: [
      {
        index: true,
        lazy: async () => ({ Component: (await import('./SettingsPage')).SettingsPage }),
      },
    ],
  },
];
